<script lang="ts">
    import { apiBaseOverride } from "../store"
    import MedialibImage from "./MedialibImage.svelte"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let slide: BlockThumbnailSlide
</script>

<!-- is admin view or not hidden -->
{#if apiBase || !slide.hide}
    <div class="slide" class:hidden="{!!slide.hide}">
        {#if slide.backgroundImage}
            <div class="background-image">
                <figure>
                    <MedialibImage id="{slide.backgroundImage}" filter="xl" />
                    <!-- Wir kriegen für alle Slides ein Hintergrundbild und ein Content-Bild (s.u.) -->
                </figure>
            </div>
        {/if}
    </div>
{/if}

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }
</style>
